<template>
  <a href="javascript:;" class="download-btn">
    <i class="fas fa-arrow-to-bottom" :data-action="'download_' + dataType" @click="downloadAsset" v-if="!isSending"></i>
    <i v-else class="fas fa-spinner-third fa-spin"></i>
    <toast-alert v-if="isSending" :isLoading="isLoading" :text="`ดาวน์โหลดสำเร็จ`"></toast-alert>

    <toast-confirmation v-if="noFriendship">
      <h3 slot="header">ไม่สามารถดาวน์โหลดได้</h3>
      <div slot="body" class="confirm-body">เป็นเพื่อนกับ @FINNOMENA เพื่อดาวน์โหลดข้อมูลกองทุน</div>
      <a @click="addFriend" slot="confirm-yes" class="left">เพิ่มเพื่อน</a>
      <a @click="cancelFriendship" slot="confirm-no" class="right">ยกเลิิก</a>
    </toast-confirmation>
  </a>
</template>
<script>
import axios from "axios";
import ToastAlert from "../../../components/miniapp/global/ToastAlert.vue";
import ToastConfirmation from "../../../components/miniapp/global/ToastConfirmation.vue";
import { mapGetters, mapActions } from "vuex";
export default {
  components: {
    ToastAlert,
    ToastConfirmation
  },
  data() {
    return {
      isSending: false,
      isLoading: false,
      noFriendship: false,
      profile: {
        userId: "",
        displayName: "",
        pictureUrl: "",
        statusMessage: ""
      }
    };
  },
  props: {
    dataType: {
      type: String,
      default: "fund"
    },
    name: {
      type: String,
      default: ""
    }
  },
  methods: {
    ...mapActions("fund", ["sendFundCard"]),
    ...mapActions("stock", ["sendStockCard"]),
    ...mapActions("global", ["findFriendship"]),
    getProfile() {
      this.$liff.ready.then(() => {
        this.$liff
          .getProfile()
          .then(profile => {
            this.profile = profile
          })
          .catch(error => {
            console.error("Error getting profile: " + error)
          })
        })
    },
    addFriend() {
      this.noFriendship = false;
      this.isLoading = false;
      this.isSending = false;

      try {
        this.$liff.openWindow({
          url: process.env.VUE_APP_OA_URL_NEW_SCHEME,
          external: false
        });
      } catch (err) {
        window.open(process.env.VUE_APP_OA_URL_NEW_SCHEME);
      }
    },
    cancelFriendship() {
      this.noFriendship = false;
      this.isLoading = false;
      this.isSending = false;
      return;
    },
    async sendCard() {
      // for test
      // let name_card = _this.name.replace(/[^\w\s]/gi, "").toLowerCase();
      // name_card = name_card.replace(/\s/g, "");
      // let obj = {
      //   line_id: "Ue7447b957b48008c0511c224567e08fe",
      //   name: name_card
      // };
      // switch (_this.dataType) {
      //   case "fund":
      //     await _this.sendFundCard(obj);
      //     break;
      //   case "stock":
      //     await _this.sendStockCard(obj);
      //     break;
      //   default:
      // }
      this.$liff.ready.then(async () => {
        await this.$liff
          .getProfile()
          .then(async profile => {
            let name_card = this.name.replace(/[^\w\s&]/gi, "").toLowerCase();
            name_card = name_card.replace(/\s/g, "");
            let obj = {
              line_id: profile.userId,
              name: name_card,
              full_name: this.name
            };
            switch (this.dataType) {
              case "fund":
                await this.sendFundCard(obj);
                break;
              case "stock":
                await this.sendStockCard(obj);
                break;
              default:
            }
          })
          .catch(error => {
            console.error("Error getting profile: " + error);
          });
      })
    },
    async downloadAsset() {
      // for test
      // const accessToken =
      //   "eyJhbGciOiJIUzI1NiJ9.c8Z7PBNj9mMN54e6ITFNMEI6bvSmKPlzJA85st77QHa99HbJ8d7lir2K51aQxeMk-KT-y663iYSLV86sR7Xd7qKox_57Th9i81ZcHlrKJ2MptqJ-H8SkuarbcFxMg2e6.swFdSoN5ExuBRzZux-JEoZyi3nTuYHqbi_0BwR4CLAI";
      this.isSending = true;
      this.isLoading = true;
      const accessToken = this.$liff.getAccessToken();
      let obj = {
        access_token: accessToken
      };
      const rs = await this.findFriendship(obj);

      if (rs.success == true && rs.data) {
        if (rs.data.friendFlag == true) {
          await this.sendCard();
          this.isLoading = false;
          setTimeout(() => {
            this.isSending = false;
          }, 1000);
          return;
        } else {
          // no friendship
          this.isLoading = false;
          this.isSending = false;
          this.noFriendship = true;
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.download-btn {
  color: $color-light-grey-2;
  margin: 0 15px;
  vertical-align: middle;
  user-select: none;
  i {
    font-size: 26px;
    vertical-align: top;
  }
}
</style>